<template>
    <div class="tw-flex tw-flex-wrap tw-gap-3 tw-mt-2">
            <div class="tw-w-full md:tw-w-1/5">
                <v-text-field
                    v-model="value.search"
                    label="Search Records"
                    outlined
                    dense
                    append-icon="mdi-magnify"
                    clearable
                ></v-text-field>
            </div>
        <v-autocomplete
            label="Production"
            item-value="value"
            :items="values_production"
            item-text="text"
            v-model="filters.production"
            outlined
            dense
            clearable
        ></v-autocomplete>

        <date-picker
            v-model="temp_date"
            isRange
            dense
            color="primary"
            label="Deposit Date"
            display-label="Deposit Date"
            hide-details="auto"
            clearable
            left
        />


        <!--            <v-autocomplete class="tw-w-full md:tw-w-1/5"-->
<!--                label="Job Category"-->
<!--                :items="values_categories"-->
<!--                v-model="filters.category"-->
<!--                multiple-->
<!--                outlined-->
<!--                dense-->
<!--                clearable-->
<!--            ></v-autocomplete>-->

        </div>
</template>

<script>

    import DatePicker from "@/Generic/DatePicker.vue";


    export default {
        name: "ActivityReportFilters",
        components: {DatePicker},
        props: {
            'value': {
                type: Object,
                required: true
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                filters: {
                    search: null,
                    production: undefined,
                    date_deposit: this.value.date_deposit || undefined,
                },
                fetch_data_response: null,
                temp_date: this.value.date_deposit || undefined,

            }
        },
        computed: {
            values_categories() {
                if (this?.valuelists?.TITLE_FUNCTIONS) {
                    return Object.values(this.valuelists?.TITLE_FUNCTIONS)
                }
                return []
            },
            values_production() {
                if (this?.valuelists?.PRODUCTIONS) {
                    return Object.values(this.valuelists?.PRODUCTIONS)
                }
                return []
            },

        },
        methods: {
            example() {
                console.log("This is just a test")
            },
        },
        watch: {
            value: {
                handler(newVal, oldVal) {
                    this.$emit('input', this.filters)
                    this.temp_date = this.value.date_deposit || undefined
                },
                deep: true,
                immediate: true,
            },
            temp_date: {
                handler(newVal, oldVal) {
                    if (!newVal || Array.isArray(newVal) && newVal.length > 1) {
                        this.$set(this.value, 'date_deposit', newVal)
                    }
                },
                deep: true,
                immediate: true,
            },
        },
    }
</script>
